<template>
  <div
    :style="{
      height: wrapperHeight,
    }"
  >
    <v-skeleton-loader
      v-if="isLoading"
      type="image"
      class="map-loading-skeleton"
    />
    <Map
      v-if="includeMap"
      :items="items"
      :should-cluster-locations="shouldClusterLocations"
      :includes-first-point="includesFirstPoint"
      :is-grey-scale="isGreyScale"
      :latest-point-is-uncertain="latestPointIsUncertain"
      @loaded="isLoading = false"
      @clickedClusteredItems="(items) => locationClicked(items[0])"
      @clickedUnclusteredItem="locationClicked"
    >
      <div slot="popup-content">
        <MapPopup
          :data="popUpData"
          is-wide
        />
      </div>
    </Map>
  </div>
</template>
<script>
import Map from '../../atoms/map/map-box';
import MapPopup from '../../atoms/map/map-popup';

export default {
  components: {
    Map,
    MapPopup,
  },
  props: {
    height: { type: [Number, String], default: 500 },
    items: { type: Array, default: () => [] },
    shouldClusterLocations: { type: Boolean, default: false },
    includesFirstPoint: { type: Boolean, default: true },
    isGreyScale: { type: Boolean, default: false },
    latestPointIsUncertain: { type: Boolean, default: false },
  },
  data() {
    return {
      includeMap: false,
      isLoading: true,
      popUpData: null,
    };
  },
  computed: {
    wrapperHeight() {
      if (typeof this.height === 'string') {
        return this.height;
      }

      return `${this.height}px`;
    },
  },
  mounted() {
    // so that content will display - and not wait for map to load first
    setTimeout(() => { this.includeMap = true; }, 10);
  },
  methods: {
    locationClicked(locationProperties) {
      this.popUpData = locationProperties;
    },
  },
};
</script>
<style lang="scss" scoped>
.map-loading-skeleton {
  width: 100%;
  height: 100%;
  ::v-deep .v-skeleton-loader__image {
    height: 100%;
  }
}
</style>
